export default {
      id: "common__checkbox-usage",
      viewBox: "0 0 25 24",
      url: __webpack_public_path__ + "img/icons.svg#common__checkbox",
      toString: function () {
        return this.url;
      }
    }